import React from "react";
import "../mspClientAccessLevel.scss";
import RoleItem from "./RoleItem";
import { RoleAction } from "../MSPClientAccessLevels";

const RolesBlock = ({
  data = [],
  updatingRoleLoading = {},
  isView = false,
  onItemClick = (item) => { },
  onDuplicateRole = (item) => { },
  onDeleteRole = (item) => { },
  onAccessLevelRole = (item) => { }
}) => {
  return (
    <table className="w-100 table-wrapper hide-scrollbar radius-8 mspClientAccessLevelTable">
      {
        data?.length == 0 ? (<div className="mt-5 f-grey d-flex justify-content-center align-items-center">No access roles available</div>) : (
          <div className="border-parent" style={{ borderRadius: "8px" }}>
            {data?.map((list) => {
              const isUpdating = updatingRoleLoading?.roleId === list?.objId_AccessRole;
              return (
                <RoleItem
                  name={list?.RoleName}
                  description={list?.RoleDescription}
                  isUpdating={isUpdating}
                  isDuplicating={updatingRoleLoading?.action === RoleAction.Duplicate}
                  isDefault={list?.IsDefault === 1}
                  menu={list?.menu}
                  isView={isView}
                  onItemClick={() => { onItemClick(list) }}
                  onMenuItemClick={(e, item) => {
                    if (item.isEnabled === true) {
                      if (item.pageEnum === 577) {
                        onDuplicateRole(list?.objId_AccessRole);
                      }
                      if (item.pageEnum === 578) {
                        onDeleteRole(list?.objId_AccessRole);
                      }
                      if (item.pageEnum === 552 || item.pageEnum === 562) {
                        onAccessLevelRole(list);
                      }
                      e.target.closest(".hg-white-dropdown").click();
                    }
                  }}
                />
              );
            })}
          </div>
        )
      }
    </table>
  );
};

export default RolesBlock;
